/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon32Regular = forwardRef('NetCloudIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.564 25.998A1.06 1.06 0 0 1 22.5 26h-14a7.625 7.625 0 0 1-2.066-14.93C7.268 7.034 10.842 4 15.125 4a8.874 8.874 0 0 1 7.871 4.772 8.626 8.626 0 0 1-.431 17.226ZM15.125 6a6.876 6.876 0 0 0-6.82 6.005 1 1 0 0 1-.796.855A5.625 5.625 0 0 0 8.548 24h13.936a6.625 6.625 0 0 0-.108-13.25h-.02a1 1 0 0 1-.918-.603A6.877 6.877 0 0 0 15.125 6Z" })));
});
